import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import calcService from "data/calc"
// components
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
// lib
import api_match from 'data/interface/api'
import multifamilyService from 'data/multifamily'
import propertyService from 'data/property'
// styles
import { Label_s } from 'styles/app-styles'
import DataTable_s from 'components/table/data-table-styles'
import { UnitDetailMfGrid_s } from 'components/property/reports/report-styles'

interface ReportMfGridProps {
  selected: number[],
  setSelected: Function
}

const ReportMfGrid: FC<ReportMfGridProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())

  useEffect(() => {
    const multifamilySubscription = multifamilyService.stream().subscribe(data => {
      api_match(
        data,
        init  => {
          setData(_.sortBy(init.value, ['sortorder']));
          props.setSelected(init.value);
        },
        ok    => {
          setData(_.sortBy(ok.value, ['sortorder']));
          props.setSelected(ok.value);
        },
        err   => {
          setData(err.value)
        },
        fetch => {}
      )
    })
    return function cleanup() {
      multifamilySubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    setPropertyId(propertyService.getStoredPropertyId());
    if (_.isNil(propertyId)) return
    multifamilyService.fetchByPropertyId(propertyService.getStoredPropertyId())
  }, [propertyService.getStoredPropertyId()])

  return (
    <UnitDetailMfGrid_s>
      <Label_s>Units</Label_s>
      <DataTable_s>
        <DataTable
          value={data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          emptyMessage="No records found"
          selection={props.selected}
          onSelectionChange={(e)=>props.setSelected(e.value)}
        >
          <Column selectionMode="multiple" style={{width: '20px'}} />
          <Column header="Sort Order" field="sortorder" sortable={true} style={{width: '60px'}} />
          <Column field="unitdescription" header="Unit Description" sortable={true} style={{width: '150px'}}/>
        </DataTable>
      </DataTable_s>
    </UnitDetailMfGrid_s>
  )
}

export default ReportMfGrid
